import { baseUiInitialState, baseUiReducers } from '@hwm/ui-lib/core/store';
import { createSlice } from '@reduxjs/toolkit';

export const mastsUiSlice = createSlice({
  name: 'masts-ui',
  initialState: baseUiInitialState,
  reducers: {
    ...baseUiReducers,
  },
});
